import { Currency } from '@seapoint/server/enums';
import { Stack } from '../../../design-system/stack/stack';
import { cn } from '../../../utils/cn';
import { getAmountWithCurrency } from '../../../utils/get-amount-with-currency';

type AccountSummaryCardProps = {
  id: string;
  bankName: string;
  bankLogo: string;
  currency: Currency;
  balance: number;
  isSelected: boolean;
  onSelect: (id: string) => void;
};

export const AccountSummaryCard = ({
  id,
  bankName,
  bankLogo,
  currency,
  balance,
  isSelected,
  onSelect,
}: AccountSummaryCardProps) => {
  const accountBalance = getAmountWithCurrency({ amount: balance, currency, isAccountBalance: true });

  return (
    <button
      className={cn(
        'relative flex h-[84px] w-[280px] flex-col rounded-lg border-2 px-5 py-4 transition-all duration-200 hover:bg-accent',
        isSelected ? 'border-primary bg-white' : 'border-transparent bg-muted',
      )}
      onClick={() => onSelect(id)}
    >
      <Stack space={2} className="w-[240px]">
        <h2 className="truncate text-left text-xs leading-4 font-medium text-black">
          {bankName} ({currency.toUpperCase()})
        </h2>
        <p className="text-left text-xl leading-7 font-medium text-black">{accountBalance}</p>
      </Stack>
      <div className="absolute top-2 right-2 flex h-8 w-8 items-center justify-center overflow-clip rounded-full">
        <img src={bankLogo} alt={`${bankName} logo`} loading="eager" fetchpriority="high" />
      </div>
    </button>
  );
};
